
import React, { useCallback, useMemo, useState } from "react";
import ReactSelect, { components } from "react-select";

const customStyles = {
  control: (base, state) => ({
    ...base,
    borderRadius: state.isFocused ? "8px 8px 0 0" : "8px",
    boxShadow: "none",
    height: 55,
    "&:hover": {},
  }),
  option: (styles, { isDisabled }) => ({
    ...styles,
    color: isDisabled ? "#ccc" : styles.color,
    cursor: isDisabled ? "not-allowed" : "default",
  }),
};

const Option = (props) => {
  const { isSelected, label, data } = props;
  const checkboxId = `selectMulti-${String(data?.value ?? label)}`;

  return (
    <components.Option {...props}>
      <label
        htmlFor={checkboxId}
        style={{ display: "flex", alignItems: "center", gap: 8 }}
      >
        <input
          id={checkboxId}
          type="checkbox"
          checked={isSelected}
          readOnly
          aria-label={label}
          onClick={(e) => {}} 
        />
        <span>{label}</span>
      </label>
    </components.Option>
  );
};



/**
 * Shows "+N selected" summary (works even when controlShouldRenderValue={false})
 * IMPORTANT: pass full props to components.ValueContainer to keep selectProps intact.
 */
const ValueContainer = (props) => {
  const { children, getValue, selectProps } = props;

  const maxToShow = selectProps?.maxToShow ?? 3;

  // prefer-destructuring
  const { length } = getValue() || [];

  return (
    <components.ValueContainer {...props}>
      {children}

      {!selectProps?.inputValue && length > maxToShow && (
        <span style={{ marginLeft: 8, fontSize: '1rem',fontFamily: 'VodafoneRg-Bold',color: "#e74c3d" }}>
          + {length - maxToShow} selected {selectProps?.mode === "CHALLENGE" ? '(Max 4 challenge)' : null} 
        </span>
      )}
    </components.ValueContainer>
  );
};


const IdeaDropdownWithSearch = ({ dataList, sendDataToParent,mode }) => {

  const [selectedOptions, setSelectedOptions] = useState([]);

  const options = useMemo(
    () =>
      (dataList || []).map(({ id, value, title }) => ({
        value: id ?? value,
        label: title,
      })),
    [dataList]
  );

  const handleChange = useCallback(
    (nextSelected) => {
      const safeSelected = nextSelected || [];
      setSelectedOptions(safeSelected);
      sendDataToParent?.(safeSelected);
    },
    [sendDataToParent]
  );

  const handleRemove = useCallback(
    (valueToRemove) => {
      setSelectedOptions((prev) => {
        const updated = prev.filter((opt) => opt.value !== valueToRemove);
        sendDataToParent?.(updated);
        return updated;
      });
    },
    [sendDataToParent]
  );

  const MAX_CHALLENGE = 4;

  const isOptionDisabled = (option) => {
    if (mode !== "CHALLENGE") return false;
    const alreadySelected = selectedOptions.some(
      (s) => s.value === option.value
    );
    if (alreadySelected) return false;
    return selectedOptions.length >= MAX_CHALLENGE;
  };

  return (
    <div>
      <ReactSelect
        options={options}
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{ Option, ValueContainer }}
        onChange={handleChange}
        value={selectedOptions}
        styles={customStyles}
        controlShouldRenderValue={false}
        maxToShow={0} // custom prop used by ValueContainer
        isOptionDisabled={ isOptionDisabled}
        mode={mode}

      />

      {/* Custom display area outside */}
      <div
        style={{
          marginTop: 10,
          display: "flex",
          flexWrap: "wrap",
          gap: 5,
        }}
      >
        {selectedOptions.map(({ value, label }) => (
          <span
            key={value}
            style={{
              background: "#e0e0e0",
              padding: 5,
              borderRadius: 4,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {label}
            <button
              type="button"
              onClick={() => handleRemove(value)}
              style={{
                marginLeft: 5,
                cursor: "pointer",
                border: "none",
                background: "none",
                margin: "auto 5px",
                fontSize: "1.4rem",
                lineHeight: 1,
              }}
              aria-label={`Remove ${label}`}
            >
              ×
            </button>
          </span>
        ))}
      </div>
    </div>
  );
};

export default IdeaDropdownWithSearch;